const cancelledEventIdsSet = new Set([
  'Little Rock_AR_2024-11-22',
  'Grand Rapids_MI_2024-11-29',
  'Knoxville_TN_2024-12-06',
  'Loveland_CO_2024-12-06',
  'Richmond_VA_2025-05-30',
]);

export const excludeCancelledEvents = (eventIds) => {
  return eventIds.filter((id) => !cancelledEventIdsSet.has(id));
};